import { render, staticRenderFns } from "./AlertsSummaryPanel.global.vue?vue&type=template&id=494c3052&lang=pug&"
import script from "./AlertsSummaryPanel.global.vue?vue&type=script&lang=ts&"
export * from "./AlertsSummaryPanel.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports